export default __webpack_public_path__ + "static/media/colombia.6f0485ba.png";